import { Cache, Data, Variables } from "@urql/exchange-graphcache";

//A purchase may use up a personal pack offer, so the offers are fetched again
export const invalidatePackOffers = (
  result: Data,
  args: Variables,
  cache: Cache
) => {
  if (result !== null) cache.invalidate("Query", "packOffers");
};
